/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requirement_OptionalInputs */

const en_task_requirement_optional = /** @type {(inputs: Task_Requirement_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const pt_br2_task_requirement_optional = /** @type {(inputs: Task_Requirement_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional`)
};

/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Task_Requirement_OptionalInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requirement_optional = /** @type {((inputs?: Task_Requirement_OptionalInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requirement_OptionalInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requirement_optional(inputs)
	return pt_br2_task_requirement_optional(inputs)
});